const earlySupporterPlans = {
  "634928": {period: "year", name : "Early Supporter Professional Yearly", price: 29}, //yearly early supporter
  "634361": {period: "month", name : "Early Supporter Professional Monthly ", price: 2.5}, //@5 but only 1 user with 50% discount on it
}

const proPlans = Object.assign(
  {
    "647368": {period: "year", name : "Professional Yearly", price: 96}, //yearly pro @96
    "651308": {period: "month", name : "Professional Monthly", price: 12},

    "674822": {period: "year", name : "Professional Yearly", price: 120},
    "758624": {period: "month", name : "Professional Monthly", price: 15},


    "883564": {period: "month", name : "Professional Monthly", price: 19},
    "883571": {period: "year", name : "Professional Yearly", price: 156}, //bug
    "889858": {period: "year", name : "Professional Yearly", price: 156},
  }, 
  earlySupporterPlans
)

const bizPlans = {
  "758628": {period: "year", name : "Business Yearly", price: 392},
  "758627": {period: "month", name : "Business Monthly", price: 49},
}

const currentPlans = ["883571", "889858", "883564", "758627", "758628"]


const plans = Object.assign({}, proPlans, bizPlans)

export { plans, proPlans, currentPlans }

export function isCurrentPlan(planId) {
  return currentPlans.includes(planId)
}

export function isEarlySupporterPlan(planId) {
  return (planId in earlySupporterPlans)
}

export function isProPlan(planId) {
  return (planId in proPlans)
}

export function hasProFeatures(planId) {
  return (planId in proPlans)
}

export function isBizPlan(planId) {
  return (planId in bizPlans)
}

export function hasBizFeatures(planId) {
  return (planId in bizPlans)
}